export default {"src":"/_next/static/media/News-Icon.704afff0.svg","height":28,"width":27};